import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './style.sass'
import { CheckboxField } from '../FormFields'

const Table = ({
  // Main props
  title,
  headers,
  rows,
  onRowClick = () => { },
  disableHoverEffect = false,
  // Row selection props
  selectionVisible = false,
  selectionDisabled = false,
  defaultSelectedRows = [],
  onSelectedRowsChange = () => { }
}) => {
  // ===== Local state =====
  const [selectedRows, setSelectedRows] = useState([])

  // ===== Side effects  =====
  useEffect(() => {
    // Setting default selected rows
    if (Array.isArray(defaultSelectedRows) && defaultSelectedRows.length > 0) {
      setSelectedRows(defaultSelectedRows)
    }
  }, [defaultSelectedRows])

  useEffect(() => {
    // Triggering onSelectedRowsChange when selected rows changes
    onSelectedRowsChange(selectedRows)
  }, [selectedRows])

  // ===== Methods =====
  const onAllRowSelected = (isSelected) => {
    setSelectedRows(isSelected ? rows : [])
  }

  const onRowSelected = (isSelected, row) => {
    if (isSelected) {
      // Add to selectedRows if not already present
      setSelectedRows(rows => rows.find(x => x.id === row.id) ? rows : [...rows, row])
    } else {
      // Remove from selectedRows if present
      setSelectedRows(rows => rows.filter(x => x.id !== row.id))
    }
  }

  const renderHeader = () => {
    return (
      <div className="data-table-row">
        {!selectionVisible || (
          <div className="data-table-cell header">
            <CheckboxField
              name='select-all'
              value={rows?.length && selectedRows?.length === rows?.length}
              onChange={(isSelected) => onAllRowSelected(isSelected)}
              disabled={selectionDisabled}
            />
          </div>
        )}
        {headers && headers.map((header, key) => {
          return <div key={`headers-${key}`} className="data-table-cell header">{header}</div>
        })}
      </div>
    )
  }

  const renderDataEmptyMessage = () => {
    if (rows?.length === 0) {
      return (
        <div className="data-empty-row">
          No records
        </div>
      )
    }
  }
 
  const renderDataRows = () => {
    return rows && rows.map((row, key) => (
      <div key={`rows-${key}`} className="data-table-row" onClick={() => onRowClick(row)}>
        {!selectionVisible || (
          <div className={`data-table-cell data ${!disableHoverEffect && 'with-hover-effect'}`}>
            <CheckboxField
              name={`select-row-${row.id}`}
              value={!!selectedRows?.find(x => x.id === row.id)}
              onChange={(isSelected) => onRowSelected(isSelected, row)}
              disabled={selectionDisabled}
            />
          </div>
        )}
        {row && row.data && row.data.map((data, dataKey) => (
          <div
            key={`row-data-${key}-${dataKey}`}
            className={`data-table-cell data ${dataKey === 2 && 'extra-padding'} ${!disableHoverEffect && 'with-hover-effect'}`}
          >
            {data}
          </div>
        ))}
      </div>
    ))
  }

  return (
    <div className="data-table-component-container">
      {!title || <p className='table-title'>{title}</p>}
      <div className="data-table">
        <div className="data-table-body">
          {renderHeader()}
          {renderDataRows()}
        </div>
      </div>
      {renderDataEmptyMessage()}
    </div>
  )
}

Table.propTypes = {
  title: PropTypes.string,
  headers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  rows: PropTypes.arrayOf(PropTypes.shape({ data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])) })).isRequired,
  onRowClick: PropTypes.func,
  disableHoverEffect: PropTypes.bool,
  selectionVisible: PropTypes.bool,
  selectionDisabled: PropTypes.bool,
  onSelectedRowsChange: PropTypes.func
}

export default Table